<template>
  <v-sheet :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
    <v-container class="main-container">
      <v-row>
        <v-card class="pa-0 rounded-0 elevation-0 mt-2" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="ibDetails" :items-per-page="10" :footer-props="{
              'items-per-page-options': [10, 25, 50, 100],
              'items-per-page-text': 'Rows per page:'
            }" class="pa-0 rounded-0 elevation-0" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data....</span>
                </div>
              </template>

              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>

              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.name="{ item }" v-if="$canRoute('create-new-user-account') === 1">
                <router-link class="text-capitalize text--ash" :to="`/registered-user-details/${item.ib_id}`">
                  {{ item.name }}
                </router-link>
              </template>
              <template v-slot:item.name="{ item }" v-else>
                {{ item.name }}
              </template>
              <template v-slot:item.total_business="{ item }">
                {{ Number(item.total_business).toFixed(2) }}
              </template>

              <template v-slot:item.details="{ item }">
                <router-link class="links text-decoration-none"
                  :to="{ path: '/partner-list-details', query: { id: item.ib_id } }">
                  <v-icon color="#039de9" small>mdi-eye-outline</v-icon>
                </router-link>
              </template>

            </v-data-table>
          </v-sheet>
        </v-card>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { IBREQUEST__ACTIONS } from "@/store/action-types";
export default {
  name: 'TransactionDummyTable',
  data() {
    return {
      search: "",
      headers: [
        // { text: "SL", value: "sl" },
        { text: "IB ID", value: "ib_id" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Total Clients", value: "total_clients" },
        { text: "Total Business", value: "total_business" },
        { text: "New Clients", value: "new_clients" },
        { text: "Trading Volume", value: "total_trading_volume" },
        { text: "Commission Earning", value: "total_commission_earning" },
        { text: "Total Trade", value: "total_trade" },
        { text: "Performance Score", value: "performance_score" },
      ],
    };
  },
  computed: {
    ...mapState("ibrequest", ["ibDetails", "isLoading"]),
    loading() {
      return this.isLoading;
    }
  },
  methods: {
    ...mapActions("ibrequest", [IBREQUEST__ACTIONS.TOPIBDETAILS]),
    async fetchibDetails() {
      await this[IBREQUEST__ACTIONS.TOPIBDETAILS]({
        page: 1,
        limit: 10,
        search: this.search || "",
        filter_by: this.expenseShorting || ""
      });
    },
  },

  async created() {
    await this.fetchibDetails();
     if (this.$canRoute('top-performed-ib') === 1)
      this.headers.push({ text: "Details", value: "details" });
    }
  };
</script>

<style scoped>
.transactionTable {
  overflow-x: auto;
}
</style>
